import { Check, Circle, ChevronRight, Eye, PartyPopper, Loader2 } from "lucide-react";

const hasRules = (r) => {
  if (!r) return false;
  if (Array.isArray(r.custom) && r.custom.length) return true;
  return ["smoking", "pets", "noise", "parties", "visitors"].some((k) => (r[k] || "").trim());
};

export function GuideChecklist({ prop, onEdit, onViewGuest, onPublish, publishing }) {
  const items = [
    { key: "basic", label: "Nome e indirizzo", done: !!prop.basic?.address && prop.name && prop.name !== "La mia struttura", essential: true },
    { key: "photos", label: "Foto", done: (prop.branding?.gallery || []).length > 0 || !!prop.branding?.cover },
    { key: "checkin", label: "Check-in / Check-out", done: !!prop.checkin?.time && !!prop.checkout?.time, essential: true },
    { key: "wifi", label: "Wi-Fi", done: !!prop.wifi?.network, essential: true },
    { key: "access", label: "Informazioni di accesso", done: !!(prop.access?.door_instructions || prop.access?.building_entrance || prop.access?.keybox), essential: true },
    { key: "rules", label: "Regole", done: hasRules(prop.house_rules) },
    { key: "amenities", label: "Servizi", done: (prop.amenities || []).length > 0 || (prop.extras || []).some((e) => e.enabled) },
    { key: "tax", label: "Tassa di soggiorno", done: !!prop.tourist_tax?.enabled && prop.tourist_tax?.amount != null },
    { key: "contact", label: "Contatti", done: !!(prop.contact?.phone || prop.contact?.email || prop.contact?.whatsapp), essential: true },
    { key: "concierge", label: "Concierge AI", done: !!prop.ai_concierge?.enabled },
  ];
  const doneCount = items.filter((i) => i.done).length;
  const percent = Math.round((doneCount / items.length) * 100);
  const ready = items.filter((i) => i.essential).every((i) => i.done);

  return (
    <div className="rounded-3xl bg-white border border-slate-100 p-5" data-testid="guide-checklist">
      {ready ? (
        <div className="text-center">
          <PartyPopper className="w-8 h-8 text-blue-500 mx-auto" />
          <h3 className="font-serif-display text-xl text-slate-900 mt-2" data-testid="checklist-ready">🎉 La tua guida è pronta</h3>
          <p className="text-sm text-slate-500 mt-1">Hai completato le informazioni essenziali. Puoi pubblicarla o vederla come un ospite.</p>
        </div>
      ) : (
        <>
          <div className="flex items-center justify-between">
            <p className="font-display font-bold text-slate-900">Completa la tua guida</p>
            <span className="font-display font-extrabold text-blue-600" data-testid="checklist-percent">{percent}%</span>
          </div>
          <p className="text-sm text-slate-500 mt-1">La tua guida è pronta al {percent}%. Continua a personalizzarla.</p>
        </>
      )}
      <div className="mt-2 h-2.5 rounded-full bg-slate-100 overflow-hidden"><div className="h-full rounded-full bg-blue-500 transition-all duration-700" style={{ width: `${percent}%` }} /></div>

      <ul className="mt-4 space-y-1.5">
        {items.map((it) => (
          <li key={it.key}>
            <button onClick={onEdit} data-testid={`checklist-item-${it.key}`} className="w-full flex items-center gap-2.5 py-1.5 text-left">
              {it.done
                ? <Check className="w-4 h-4 text-emerald-500 shrink-0" />
                : <Circle className="w-4 h-4 text-slate-300 shrink-0" />}
              <span className={`text-sm flex-1 ${it.done ? "text-slate-400 line-through" : "text-slate-700 font-medium"}`}>{it.label}</span>
              {!it.done && <ChevronRight className="w-4 h-4 text-slate-300" />}
            </button>
          </li>
        ))}
      </ul>

      {ready ? (
        <div className="mt-4 flex gap-2">
          <button onClick={onViewGuest} data-testid="checklist-view-guest" className="flex-1 rounded-full border border-slate-200 text-slate-700 font-semibold py-3 inline-flex items-center justify-center gap-1.5"><Eye className="w-4 h-4" />Come ospite</button>
          <button onClick={onPublish} disabled={publishing} data-testid="checklist-publish" className="flex-1 rounded-full bg-blue-500 text-white font-semibold py-3 disabled:opacity-60 inline-flex items-center justify-center gap-1.5">{publishing ? <Loader2 className="w-4 h-4 animate-spin" /> : "Pubblica la guida"}</button>
        </div>
      ) : (
        <button onClick={onEdit} data-testid="checklist-continue" className="mt-4 w-full rounded-full bg-slate-900 text-white font-semibold py-3">Continua configurazione</button>
      )}
    </div>
  );
}
